var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7893 5.20329L10.8126 3.22529C9.46125 1.87195 8.78592 1.19662 8.05992 1.35662C7.33458 1.51662 7.00592 2.41462 6.34792 4.20995L5.90258 5.42529C5.72725 5.90395 5.63925 6.14329 5.48125 6.32862C5.41045 6.41179 5.32987 6.48611 5.24125 6.54995C5.04392 6.69195 4.79858 6.75929 4.30792 6.89462C3.20125 7.19995 2.64725 7.35262 2.43858 7.71462C2.34832 7.87128 2.30138 8.04915 2.30258 8.22995C2.30525 8.64795 2.71125 9.05395 3.52258 9.86662L4.46658 10.8106L1.48258 13.7973C1.39166 13.8937 1.34187 14.0217 1.3438 14.1542C1.34574 14.2867 1.39923 14.4132 1.49293 14.5069C1.58663 14.6006 1.71316 14.6541 1.84566 14.6561C1.97816 14.658 2.10619 14.6082 2.20258 14.5173L5.18592 11.5306L6.16325 12.5093C6.98058 13.3266 7.38925 13.736 7.80992 13.736C7.98658 13.736 8.16058 13.6906 8.31458 13.6026C8.67992 13.394 8.83325 12.8366 9.14058 11.7213C9.27525 11.2313 9.34258 10.9866 9.48392 10.7886C9.54592 10.7026 9.61792 10.624 9.69858 10.554C9.88192 10.3953 10.1199 10.306 10.5953 10.1273L11.8246 9.66529C13.6006 8.99862 14.4886 8.66462 14.6446 7.94129C14.8013 7.21729 14.1313 6.54595 12.7893 5.20329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSolid);
export default __webpack_public_path__ + "static/media/pinSolid.58814ec78991d3dd727b9a2f40edee78.svg";
export { ForwardRef as ReactComponent };